'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
var settings = require('../settings-9ee2f03f.js');
var buttonsColor = require('../buttons-color-d198c1b7.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  border-radius: 50px;\n  cursor: pointer;\n  height: 35px;\n  padding: 0 20px;\n  transition: ", ";\n  ", ";\n\n  &.button-lg {\n    height: 45px;\n    font-size: 15px;\n  }\n  &.button-md {\n    height: 40px;\n  }\n  &.button-sm {\n    height: 25px;\n    font-size: 13px;\n    padding: 0 12px;\n  }\n"], ["\n  border-radius: 50px;\n  cursor: pointer;\n  height: 35px;\n  padding: 0 20px;\n  transition: ", ";\n  ", ";\n\n  &.button-lg {\n    height: 45px;\n    font-size: 15px;\n  }\n  &.button-md {\n    height: 40px;\n  }\n  &.button-sm {\n    height: 25px;\n    font-size: 13px;\n    padding: 0 12px;\n  }\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n\n  &.z-index {\n    position: relative;\n    z-index: 13;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    border: none;\n    background-color: ", ";\n  }\n"], ["\n  ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", "\n\n  &.z-index {\n    position: relative;\n    z-index: 13;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    border: none;\n    background-color: ", ";\n  }\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n      max-width: ", ";\n    "], ["\n      max-width: ", ";\n    "]),
    _templateObject4 = _babelHelpers.taggedTemplateLiteral(["\n      min-width: ", ";\n    "], ["\n      min-width: ", ";\n    "]),
    _templateObject5 = _babelHelpers.taggedTemplateLiteral(["\n      width: ", ";\n    "], ["\n      width: ", ";\n    "]),
    _templateObject6 = _babelHelpers.taggedTemplateLiteral(["\n      height: ", ";\n    "], ["\n      height: ", ";\n    "]),
    _templateObject7 = _babelHelpers.taggedTemplateLiteral(["\n      border-radius: 4px;\n    "], ["\n      border-radius: 4px;\n    "]),
    _templateObject8 = _babelHelpers.taggedTemplateLiteral(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "]),
    _templateObject9 = _babelHelpers.taggedTemplateLiteral(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "]),
    _templateObject10 = _babelHelpers.taggedTemplateLiteral(["\n      margin: ", ";\n    "], ["\n      margin: ", ";\n    "]),
    _templateObject11 = _babelHelpers.taggedTemplateLiteral(["\n      font-family: ", ";\n    "], ["\n      font-family: ", ";\n    "]),
    _templateObject12 = _babelHelpers.taggedTemplateLiteral(["\n  color: white;\n  border: none;\n"], ["\n  color: white;\n  border: none;\n"]),
    _templateObject13 = _babelHelpers.taggedTemplateLiteral(["\n  cursor: initial;\n  &:hover {\n    background: initial;\n    ", "\n  }\n"], ["\n  cursor: initial;\n  &:hover {\n    background: initial;\n    ", "\n  }\n"]),
    _templateObject14 = _babelHelpers.taggedTemplateLiteral(["\n  margin-right: ", ";\n  ", "\n"], ["\n  margin-right: ", ";\n  ", "\n"]),
    _templateObject15 = _babelHelpers.taggedTemplateLiteral(["\n      font-size: ", "px;\n    "], ["\n      font-size: ", "px;\n    "]),
    _templateObject16 = _babelHelpers.taggedTemplateLiteral(["\n  margin-left: ", ";\n  ", "\n"], ["\n  margin-left: ", ";\n  ", "\n"]),
    _templateObject17 = _babelHelpers.taggedTemplateLiteral(["\n  margin-right: ", ";\n"], ["\n  margin-right: ", ";\n"]),
    _templateObject18 = _babelHelpers.taggedTemplateLiteral(["\n  color: ", ";\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"]),
    _templateObject19 = _babelHelpers.taggedTemplateLiteral(["\n  padding: 0px;\n  font-size: inherit;\n  font-weight: normal;\n  border: none;\n  color: ", ";\n  background: transparent;\n  height: inherit;\n\n  &:disabled {\n    color: ", ";\n  }\n"], ["\n  padding: 0px;\n  font-size: inherit;\n  font-weight: normal;\n  border: none;\n  color: ", ";\n  background: transparent;\n  height: inherit;\n\n  &:disabled {\n    color: ", ";\n  }\n"]),
    _templateObject20 = _babelHelpers.taggedTemplateLiteral(["\n  padding: 0;\n  font-size: 0.85em;\n  font-weight: normal;\n  line-height: 1.3;\n  color: inherit;\n  border-radius: 0;\n  border-bottom: 1px solid;\n  height: inherit;\n"], ["\n  padding: 0;\n  font-size: 0.85em;\n  font-weight: normal;\n  line-height: 1.3;\n  color: inherit;\n  border-radius: 0;\n  border-bottom: 1px solid;\n  height: inherit;\n"]),
    _templateObject21 = _babelHelpers.taggedTemplateLiteral(["\n  @media (min-width: 992px) {\n    display: none;\n  }\n"], ["\n  @media (min-width: 992px) {\n    display: none;\n  }\n"]),
    _templateObject22 = _babelHelpers.taggedTemplateLiteral(["\n  @media (max-width: 991px) {\n    display: none;\n  }\n"], ["\n  @media (max-width: 991px) {\n    display: none;\n  }\n"]),
    _templateObject23 = _babelHelpers.taggedTemplateLiteral(["\n  background-color: ", " !important;\n  border-color: ", " !important;\n  animation: shake ", " cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n  animation-fill-mode: forwards;\n  transform: translate3d(0, 0, 0);\n\n  @keyframes shake {\n    10%,\n    90% {\n      transform: translate3d(-0.5px, 0, 0);\n    }\n\n    20%,\n    80% {\n      transform: translate3d(1px, 0, 0);\n    }\n\n    30%,\n    50%,\n    70% {\n      transform: translate3d(-2px, 0, 0);\n    }\n\n    40%,\n    60% {\n      transform: translate3d(2px, 0, 0);\n    }\n  }\n"], ["\n  background-color: ", " !important;\n  border-color: ", " !important;\n  animation: shake ", " cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n  animation-fill-mode: forwards;\n  transform: translate3d(0, 0, 0);\n\n  @keyframes shake {\n    10%,\n    90% {\n      transform: translate3d(-0.5px, 0, 0);\n    }\n\n    20%,\n    80% {\n      transform: translate3d(1px, 0, 0);\n    }\n\n    30%,\n    50%,\n    70% {\n      transform: translate3d(-2px, 0, 0);\n    }\n\n    40%,\n    60% {\n      transform: translate3d(2px, 0, 0);\n    }\n  }\n"]),
    _templateObject24 = _babelHelpers.taggedTemplateLiteral(["\n  background: ", ";\n  border-color: ", ";\n  color: ", ";\n"], ["\n  background: ", ";\n  border-color: ", ";\n  color: ", ";\n"]);

// language=SCSS prefix=dummy{ suffix=}
var btn = styled.css(_templateObject, function (props) {
  return props.transitionNone ? "none" : "all ease-in-out " + settings.ANIMATE.fast;
}, settings.INLINE_FLEX_CENTER);

// language=SCSS prefix=dummy{ suffix=}
var button = styled__default.button(_templateObject2, btn, function (props) {
  return props.fontSize ? props.fontSize : "14";
}, function (props) {
  return props.weight ? props.weight : "bold";
}, function (props) {
  return props.redBtn && buttonsColor.redBtn;
}, function (props) {
  return props.maxWidth && styled.css(_templateObject3, props.maxWidth);
}, function (props) {
  return props.minWidth && styled.css(_templateObject4, props.minWidth);
}, function (props) {
  return props.width && styled.css(_templateObject5, props.width);
}, function (props) {
  return props.height && styled.css(_templateObject6, props.height);
}, function (props) {
  return props.squareBtn && styled.css(_templateObject7);
}, function (props) {
  return props.leftSpace && styled.css(_templateObject8, props.leftSpace);
}, function (props) {
  return props.padding && styled.css(_templateObject9, props.padding);
}, function (props) {
  return props.margin && styled.css(_templateObject10, props.margin);
}, function (props) {
  return props.disabled && disabledBtn;
}, function (props) {
  return props.validationError && validationError;
}, function (props) {
  return props.fontFamily && styled.css(_templateObject11, props.fontFamily);
}, settings.COLOR.newGrey);

var ButtonBlue = styled__default(button)(_templateObject12);

var buttonAlike = styled__default(button).attrs(function () {
  return { as: "div" };
})(_templateObject13, function (props) {
  return props.transparentDarkGreen && "color: " + settings.COLOR.darkGreen;
});

var btnIcon = styled__default.i(_templateObject14, function (props) {
  return props.gap ? props.gap + "px" : "7px";
}, function (props) {
  return props.size && styled.css(_templateObject15, props.size);
});
var btnIconRight = styled__default.i(_templateObject16, function (props) {
  return props.gap ? props.gap + "px" : "7px";
}, function (props) {
  return props.size && styled.css(_templateObject15, props.size);
});

var btnImgIcon = styled__default.img(_templateObject17, function (props) {
  return props.gap ? props.gap + "px" : "7px";
});

var loaderWrapper = styled__default.div(_templateObject17, function (props) {
  return props.gap ? props.gap + "px" : "7px";
});
var hoverWhiteText = styled.css(_templateObject18, settings.COLOR.white, settings.COLOR.textGrey);
// language=SCSS prefix=dummy{ suffix=}
var inlineLink = styled.css(_templateObject19, settings.COLOR.deepBlue, settings.COLOR.textGrey);
var underlineTextLink = styled.css(_templateObject20);

// language=SCSS prefix=dummy{ suffix=}
var onlyMobile = styled.css(_templateObject21);

// language=SCSS prefix=dummy{ suffix=}
var hiddenMobile = styled.css(_templateObject22);

// language=SCSS prefix=dummy{ suffix=}
var validationError = styled.css(_templateObject23, settings.COLOR.negativeRed, settings.COLOR.negativeRed, settings.ANIMATE.normal);

var disabledBtn = styled.css(_templateObject24, settings.COLOR.newGrey, settings.COLOR.bgGrey, settings.COLOR.white);

var RedButton = function RedButton(_ref) {
  var text = _ref.text,
      children = _ref.children,
      icon = _ref.icon,
      iconRight = _ref.iconRight,
      gap = _ref.gap,
      loading = _ref.loading,
      rest = _babelHelpers.objectWithoutProperties(_ref, ["text", "children", "icon", "iconRight", "gap", "loading"]);

  if (loading) {
    return React__default.createElement(
      button,
      rest,
      React__default.createElement(btnIcon, {
        className: "fa fa-circle-notch fa-spin",
        size: "18",
        gap: "0"
      })
    );
  }

  return React__default.createElement(
    button,
    _babelHelpers._extends({}, rest, { redBtn: true }),
    icon && React__default.createElement(btnIcon, { className: icon, gap: gap }),
    text && text,
    children && children,
    iconRight && React__default.createElement(btnIconRight, { className: iconRight, gap: gap })
  );
};
RedButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RedButton"
};

exports.RedButton = RedButton;
exports.default = RedButton;
//# sourceMappingURL=red-button.js.map
